import { ICommonSettings, IGooglePlayApiSetting } from "@kuika/kuika-cl-model";
import { PureComponent, ReactNode } from "react";
import { ICommonConfigDeleteFunctionParams, ICommonConfigSaveFunctionParams } from "../app-settings-config-container";
import { ConfigSettingSelect } from "../config-setting-select";
import { GooglePlayConnectApiSettings } from "./app-settings-config-google-play";

export interface IGooglePlayConnectApiInputState {
  showModal: boolean;
  editingGooglePlayConnectApiId: string;
}

export interface IGooglePlayConnectApiInputProps {
  parentConfigValue?: string | null;
  commonSettings: ICommonSettings;
  getSectionDescription: (contentKey: string) => ReactNode;
  handleUpdateCustomFormInput: (formItemName: string[], value: string | null) => void;
  handleCreateCommonConfig: (params: ICommonConfigSaveFunctionParams) => void;
  handleUpdateCommonConfig: (params: ICommonConfigSaveFunctionParams) => void;
  handleDeleteCommonConfig: (params: ICommonConfigDeleteFunctionParams) => void;
}

export class GooglePlayConnectApiInput extends PureComponent<
  IGooglePlayConnectApiInputProps,
  IGooglePlayConnectApiInputState
> {
  formInputName = ["androidConfig", "googlePlayApiSettingsId"];

  constructor(props: IGooglePlayConnectApiInputProps) {
    super(props);
    this.state = {
      showModal: false,
      editingGooglePlayConnectApiId: ""
    };
  }

  openModal = () => {
    this.setState({ showModal: true, editingGooglePlayConnectApiId: "" });
  };

  closeModal = () => {
    this.setState({ showModal: false });
  };

  setEditingSetting = (id: string) => {
    this.setState({ editingGooglePlayConnectApiId: id, showModal: true });
  };

  handleRestore = (): void => {
    this.props.handleUpdateCustomFormInput?.(this.formInputName, this.props.parentConfigValue ?? null);
  };

  render() {
    const {
      parentConfigValue,
      commonSettings,
      getSectionDescription,
      handleUpdateCustomFormInput,
      handleCreateCommonConfig,
      handleUpdateCommonConfig,
      handleDeleteCommonConfig
    } = this.props;

    const options = [
      { id: null, name: "Default" } as unknown as IGooglePlayApiSetting,
      ...(commonSettings.googlePlayApiSettings || [])
    ];

    return (
      <>
        <GooglePlayConnectApiSettings
          formInputName={this.formInputName}
          closeModal={this.closeModal}
          showModal={this.state.showModal}
          editingGooglePlayConnectApiId={this.state.editingGooglePlayConnectApiId}
          commonSettings={commonSettings}
          getSectionDescription={getSectionDescription}
          handleCreateCommonConfig={handleCreateCommonConfig}
          handleUpdateCommonConfig={handleUpdateCommonConfig}
          handleDeleteCommonConfig={handleDeleteCommonConfig}
        />
        <ConfigSettingSelect
          label="Configuration"
          formInputName={this.formInputName}
          options={options}
          tooltipContentKey="android_playstoresettings_configuration"
          onAddNew={this.openModal}
          onEdit={this.setEditingSetting}
          parentConfigValue={this.props.parentConfigValue}
          onRestore={this.handleRestore}
          dropdownTestId="playStoreSettingsDropdown"
          addNewTestId="playStoreSettingsDropdownAddNewButton"
          editTestId="playStoreSettingEditButton"
        />
      </>
    );
  }
}
